import i18n from '@/libs/i18n'

export default [
  { id: 'PENDING', title: i18n.t('PENDING') },
  { id: 'ACTIVE', title: i18n.t('ACTIVE') },
  { id: 'DECLINED', title: i18n.t('DECLINED') },
  { id: 'DELETED', title: i18n.t('DELETED') },
]
